<template>
  <section>
    <div class="container">
      <div class="telecom-logos">
        <svgTworld />
        <svgKT />
        <svgUPlus />
      </div>
      
      <p>
        채팅+는 SKT, KT, LG U+와 함께합니다
      </p>
    </div>
  </section>
</template>

<script>
import svgTworld from '@/svg/svgTworld'
import svgKT from '@/svg/svgKT'
import svgUPlus from '@/svg/svgUPlus'

export default {
  components: {
    svgTworld,
    svgKT,
    svgUPlus
  }
}
</script>

<style lang="scss" scoped>

section {
  --section-height: 96px;
  background: #292929;
  height: var(--section-height);
  @media screen and (max-width: 600px) {
    --section-height: 123px;
  }
}

section .container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  @media screen and (max-width: 600px) {
    flex-direction: column;
    justify-content: center;
  }
}

.telecom-logos {
  display: flex;
  align-items: center;

  svg {
    margin-right: 20px;
    @media screen and (max-width: 600px) {
      margin: 0 10px 0;
    }
  }
}

p {
  font-weight: 500;
  color: #686868;
  font-size: 16px;
  line-height: 2;
  @media screen and (max-width: 600px) {
    margin-top: 5px;
  }
}

</style>